import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { useEffect, useState, useRef } from "react";

export default function MultiselectInputHolder({
    input,
    onUpdateService,
}: any) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedValues, setSelectedValues] = useState<any>([]);
    const [selectedLabels, setSelectedLabels] = useState<any>([]);
    const dropdownRef = useRef(null);

    const handleCheckboxChange = (e: any, name: string) => {
        const { value, checked } = e.target;

        if (checked) {
            setSelectedValues((prevSelectedValues: any) => [
                ...prevSelectedValues,
                value,
            ]);
            setSelectedLabels((prevSelectedLabels: any) => [
                ...prevSelectedLabels,
                name,
            ]);
        } else {
            setSelectedValues((prevSelectedValues: any) =>
                prevSelectedValues.filter(
                    (selectedValue: any) => selectedValue !== value
                )
            );
            setSelectedLabels((prevSelectedLabels: any) =>
                prevSelectedLabels.filter(
                    (selectedLabel: any) => selectedLabel !== name
                )
            );
        }
    };

    useEffect(() => {
        if (selectedValues) {
            onUpdateService("services", selectedValues.join(", "));
        }
    }, [selectedValues]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !(dropdownRef.current as HTMLElement).contains(
                    event.target as Node
                )
            ) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="relative w-full md:px-4 group" ref={dropdownRef}>
            {/* <label className="block text-white mb-2 ">{input.label}</label> */}
            <div className="relative flex flex-col cursor-pointer">
                <div
                    className={`relative text-white border w-full py-[0.7rem] px-[2rem] rounded-full z-10 cursor-pointer flex ${
                        dropdownOpen ? "border-0 z-[9999]" : ""
                    }`}
                    onClick={() => {
                        setDropdownOpen(!dropdownOpen);
                    }}
                >
                    <span
                        className={`relative duration-150 select-none w-full`}
                    >
                        {selectedValues.length > 0 ? (
                            <span
                                className={`${
                                    !dropdownOpen ? "inline-block" : "opacity-0"
                                }`}
                            >
                                {selectedValues.length} selected
                            </span>
                        ) : (
                            <span
                                className={`${
                                    !dropdownOpen
                                        ? "inline-block opacity-70"
                                        : "opacity-0"
                                }`}
                            >
                                {input.label}
                            </span>
                        )}
                        <ChevronDownIcon
                            className={`absolute h-5 w-5 top-0 bottom-0 right-0 m-auto ${
                                dropdownOpen && "text-black rotate-180"
                            }`}
                        />
                    </span>
                </div>
                <div
                    className={`absolute top-8 py-3 px-[2rem] border border-b-0 w-full -translate-y-8 bg-white z-0 rounded-3xl ${
                        dropdownOpen
                            ? "opacity-100 pointer-events-all z-10"
                            : "opacity-0 pointer-events-none"
                    }`}
                >
                    <div className="mb-4 select-none">
                        You may select one or more
                    </div>
                    {/* {input.optionsArray.map((item: any, i: number) => {
                        return (
                            <div key={i} className="flex items-start">
                                <input
                                    type="checkbox"
                                    id={`checkbox-${i}`}
                                    name={item.name}
                                    value={item.value}
                                    className="custom-checkbox w-4 h-4 mr-2 mt-1"
                                    onChange={(e) =>
                                        handleCheckboxChange(e, item.label)
                                    }
                                ></input>
                                <label
                                    className="cursor-pointer w-fit"
                                    htmlFor={`checkbox-${i}`}
                                >
                                    {item.label}
                                </label>
                            </div>
                        );
                    })} */}
                    {input.optionsArray.map((item: any, i: number) => {
                        const optionId = `${input.name || "multiselect"}-${i}`;

                        return (
                            <div key={i} className="flex items-start">
                                <input
                                    type="checkbox"
                                    id={optionId}
                                    name={item.name}
                                    value={item.value}
                                    className="custom-checkbox"
                                    onChange={(e) =>
                                        handleCheckboxChange(e, item.label)
                                    }
                                />
                                <label
                                    htmlFor={optionId}
                                    className="cursor-pointer flex items-center"
                                >
                                    <span className="w-4 h-4 inline-block mr-2"></span>
                                    {item.label}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
            {selectedLabels.length > 0 && (
                <div className="px-4 pt-2 text-xs text-white line-clamp-2">
                    {selectedLabels.join(", ")}
                </div>
            )}
        </div>
    );
}
